import { Button, useBreakpointValue } from "@alchemy/ui";
import { CurrencyCoinDollar } from "@alchemy/ui/icons/16";

import { ViewAsPreservingLink } from "@features/common/ViewAsPreservingLink";
import useActivePlan from "@features/profile/PlanPage/hooks/useActivePlan";
import useOnDemandActions from "@features/profile/PlanPage/hooks/useOnDemandActions";
import useCurrentUser from "../../react-query/queries/useCurrentUser.ts";
import { EventPrefix, analyticsEvent } from "@util/analytics";
import { UsageCapType } from "@util/constants";
import { Path } from "@util/paths";
import { FeatureFlagKey } from "../launchdarkly/featureFlag.ts";
import useLDFeatureFlag from "../launchdarkly/useLDFeatureFlag.ts";

export const useShowSpendingCapButton = () => {
  const activePlan = useActivePlan();
  const onDemandActions = useOnDemandActions();
  const currentUser = useCurrentUser();
  const featureFlag = useLDFeatureFlag(FeatureFlagKey.SpendingCapCTA);

  if (
    !activePlan.data ||
    !onDemandActions.data ||
    !currentUser.data ||
    featureFlag.loading
  ) {
    return null;
  }

  if (!featureFlag.data) return false;

  const isBillingAdmin = currentUser.data.is_billing_admin;
  const autoScaleEnabled =
    activePlan.data.usage_cap_type === UsageCapType.AUTO_SCALE;
  const onDemandActionsSet = onDemandActions.data.length > 0;

  return isBillingAdmin && autoScaleEnabled && !onDemandActionsSet;
};

const HeaderSpendingCapButton = () => {
  const spendingCapButton = useBreakpointValue({
    base: null,
    md: (
      <Button
        as={ViewAsPreservingLink}
        to={Path.BillingSpendingCap}
        leadingIcon={<CurrencyCoinDollar className="text-grayscale-700" />}
        className="rounded-full bg-warning-200 text-grayscale-950 hover:bg-warning-100 active:bg-warning-300"
        onClick={() => {
          analyticsEvent(`${EventPrefix.SpendingCap}: Clicked CTA`);
        }}
      >
        Set a spending cap
      </Button>
    ),
  });

  return <>{spendingCapButton}</>;
};

export default HeaderSpendingCapButton;
